import React from 'react'
import { OrigamiChoice } from '../game/GameEngine'

interface OrigamiSelectorProps {
  selected: OrigamiChoice | null
  onSelect: (choice: OrigamiChoice) => void
}

// AGC: Origami choice selector component
// AGC: Allows players to choose between Rock, Paper, and Scissors
export const OrigamiSelector: React.FC<OrigamiSelectorProps> = ({ selected, onSelect }) => {
  const choices: { type: OrigamiChoice; emoji: string; name: string; description: string }[] = [
    {
      type: 'ROCK',
      emoji: '🪨',
      name: 'Rock',
      description: 'Crushes Scissors'
    },
    {
      type: 'PAPER',
      emoji: '📄',
      name: 'Paper',
      description: 'Covers Rock'
    },
    {
      type: 'SCISSORS',
      emoji: '✂️',
      name: 'Scissors',
      description: 'Cuts Paper'
    }
  ]

  return (
    <div className="grid grid-cols-1 gap-3">
      {choices.map((choice) => (
        <button
          key={choice.type}
          onClick={() => onSelect(choice.type)}
          className={`
            origami-button p-4 text-left transition-all duration-200
            ${selected === choice.type 
              ? `origami-${choice.type.toLowerCase()} ring-2 ring-white/50 scale-105` 
              : 'bg-white/10 hover:bg-white/20'
            }
          `}
        >
          <div className="flex items-center space-x-4">
            <span className="text-3xl">{choice.emoji}</span>
            <div>
              <h3 className="font-bold text-white">{choice.name}</h3>
              <p className="text-sm text-gray-300">{choice.description}</p>
            </div>
          </div>
        </button>
      ))}
    </div>
  )
}
